import axios from '@/http/index';

const base = '';

// 前台查看评价功能
export const getCommentList = (id, params) => axios.get(`${base}/core/lookTechnicianScore/lookAssess?mainId=${id}`, params).then((res) => res.data);
